import { motion, AnimatePresence } from "framer-motion";
import { FaHeartbeat } from "react-icons/fa";

const LoadingScreen = () => (
    <AnimatePresence>
        <motion.div
            data-testid="loading-screen"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-gradient-to-br from-white via-sky-50 to-brand-50 dark:from-slate-950 dark:via-slate-900 dark:to-brand-900"
        >
            <div className="flex flex-col items-center gap-6">
                <motion.div
                    animate={{ scale: [1, 1.15, 1] }}
                    transition={{ duration: 1.2, repeat: Infinity, ease: "easeInOut" }}
                    className="relative"
                >
                    <div className="absolute inset-0 rounded-full bg-brand-500/30 blur-xl" />
                    <div className="relative w-20 h-20 rounded-2xl bg-gradient-to-br from-brand-700 to-brand-400 flex items-center justify-center shadow-2xl">
                        <FaHeartbeat className="text-white text-3xl" />
                    </div>
                </motion.div>
                <div className="text-center">
                    <div className="font-heading font-bold text-2xl text-brand-800 dark:text-brand-200">Ezhil Biomedical</div>
                    <div className="text-sm text-slate-500 dark:text-slate-400 mt-1 tracking-wider">Loading premium experience...</div>
                </div>
            </div>
        </motion.div>
    </AnimatePresence>
);

export default LoadingScreen;
